import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { BRAND } from "../lib/site";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-white/20 py-4 font-body text-white placeholder:text-white/30 focus:border-[#00D166] focus:outline-none transition-colors";

  return (
    <div className="min-h-screen bg-[#030712] text-white flex flex-col" data-testid="login-page">
      <div className="p-6 lg:p-10">
        <Link to="/" className="inline-flex items-center gap-2 font-body text-sm text-white/60 hover:text-[#00D166] transition-colors" data-testid="login-back-home">
          <ArrowLeft size={16} /> Back to site
        </Link>
      </div>
      <div className="flex-1 grid place-items-center px-6">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-3 mb-10">
            <img src={BRAND.logo} alt="Yes Global" className="h-11 w-11 rounded-full ring-1 ring-white/20" />
            <div className="leading-none">
              <span className="block font-display text-base font-bold">YES GLOBAL</span>
              <span className="block font-body text-[10px] tracking-[0.32em] text-[#00D166]">CONSULTANTS</span>
            </div>
          </div>
          <h1 className="font-display text-4xl font-bold tracking-tight flex items-center gap-3">
            <Lock size={26} className="text-[#00D166]" /> Admin
          </h1>
          <p className="mt-3 font-body text-white/50 text-sm">Sign in to manage enquiries & blog posts.</p>

          <form onSubmit={submit} className="mt-10 space-y-8" data-testid="login-form">
            <input data-testid="login-email-input" type="email" placeholder="Email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input data-testid="login-password-input" type="password" placeholder="Password" className={inputCls} value={password} onChange={(e) => setPassword(e.target.value)} required />
            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full font-body text-sm font-semibold bg-[#00D166] text-[#030712] py-4 hover:bg-white transition-colors duration-300 disabled:opacity-60"
            >
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
